'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Side = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _sidesMap;

var _cssLonghand = require('@team-griffin/css-longhand');

var _cssLonghand2 = _interopRequireDefault(_cssLonghand);

var _lodash = require('lodash.reduce');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Side = exports.Side = {
  A: 'a',
  X: 'x',
  Y: 'y'
};

var actualSides = ['left', 'top', 'right', 'bottom'];

var sidesMap = (_sidesMap = {}, _defineProperty(_sidesMap, Side.A, [0, 1, 2, 3]), _defineProperty(_sidesMap, Side.X, [0, 2]), _defineProperty(_sidesMap, Side.Y, [1, 3]), _sidesMap);

var cssSides = function cssSides(prop, sides, value) {
  return (0, _cssLonghand2.default)(prop, (0, _lodash2.default)(sidesMap[sides], function (result, idx) {
    return _extends({}, result, _defineProperty({}, actualSides[idx], value));
  }, {}));
};

exports.default = cssSides;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ux/button/node_modules/@team-griffin/css-sides/lib/index.js
// module id = 1287
// module chunks = 0